module.exports = __webpack_public_path__ + "static/media/logo_gsb.436bc572.png";